import axios from "axios";
import { getToken } from "./auth";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
    timeout: 15000,
});

// Attach admin token when present
apiClient.interceptors.request.use((cfg) => {
    const t = getToken();
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
    return cfg;
});

// ---------- FORMS ----------
export async function submitQuote(data) {
    const { data: res } = await apiClient.post("/contact/quote", data);
    return res;
}
export async function submitEnrollment(data) {
    const { data: res } = await apiClient.post("/courses/enroll", data);
    return res;
}

// ---------- BLOG PUBLIC ----------
export async function fetchPosts(params = {}) {
    const { data } = await apiClient.get("/blog/posts", { params });
    return data;
}
export async function fetchPost(slug) {
    const { data } = await apiClient.get(`/blog/posts/${slug}`);
    return data;
}

// ---------- BLOG ADMIN ----------
export async function fetchAllPosts() {
    const { data } = await apiClient.get("/admin/blog/posts");
    return data;
}
export async function fetchPostById(id) {
    const { data } = await apiClient.get(`/admin/blog/posts/${id}`);
    return data;
}
export async function createPost(post) {
    const { data } = await apiClient.post("/admin/blog/posts", post);
    return data;
}
export async function updatePost(id, post) {
    const { data } = await apiClient.put(`/admin/blog/posts/${id}`, post);
    return data;
}
export async function deletePost(id) {
    const { data } = await apiClient.delete(`/admin/blog/posts/${id}`);
    return data;
}
